var map = {
	"./data/C-PVC Pipe Fitting": "4319",
	"./data/C-PVC Pipe Fitting.json": "4319",
	"./data/Double Lever Mixer": "997d",
	"./data/Double Lever Mixer.json": "997d",
	"./data/Drainage Fitting": "a9ec",
	"./data/Drainage Fitting.json": "a9ec",
	"./data/Drainer": "ce4a",
	"./data/Drainer.json": "ce4a",
	"./data/H- PVC Pipe Fitting": "7ae8",
	"./data/H- PVC Pipe Fitting.json": "7ae8",
	"./data/Hose": "3676",
	"./data/Hose.json": "3676",
	"./data/Hose_OLd": "546e",
	"./data/Hose_OLd.json": "546e",
	"./data/PP-R Fitting": "2565",
	"./data/PP-R Fitting.json": "2565",
	"./data/Shattaf Set": "8b37",
	"./data/Shattaf Set.json": "8b37",
	"./data/Shower Set": "edb8",
	"./data/Shower Set.json": "edb8",
	"./data/Single Function Water Tap": "0800",
	"./data/Single Function Water Tap.json": "0800",
	"./data/Single Lever Mixer": "8ea7",
	"./data/Single Lever Mixer.json": "8ea7",
	"./data/Valve": "8d8d",
	"./data/Valve.json": "8d8d",
	"./data/Water Filter": "bc10",
	"./data/Water Filter.json": "bc10",
	"./data/Water Pump": "1442",
	"./data/Water Pump.json": "1442",
	"./img/Single Function Water Tap/AS1860033.jpg": "0397",
	"./img/Single Function Water Tap/AS3485009.jpg": "2e19",
	"./img/Single Function Water Tap/AS3485016.jpg": "61ec",
	"./img/Single Function Water Tap/AS3485023.jpg": "b6c0",
	"./img/Single Function Water Tap/AS3485030.jpg": "3b09",
	"./img/Single Function Water Tap/W-AS1860033.jpg": "890b",
	"./img/Single Function Water Tap/W-AS3485009.jpg": "a937",
	"./img/Single Function Water Tap/W-AS3485016.jpg": "b1ac",
	"./img/Single Function Water Tap/W-AS3485023.jpg": "5a14",
	"./img/Single Function Water Tap/W-AS3485030.jpg": "66d9",
	"./img/cpvc-pipefitting/W-G01.jpg": "8d97",
	"./img/cpvc-pipefitting/W-G02.jpg": "4f46",
	"./img/cpvc-pipefitting/W-G03.jpg": "b377",
	"./img/cpvc-pipefitting/W-G04.jpg": "2918",
	"./img/cpvc-pipefitting/W-G05.jpg": "6d2f",
	"./img/cpvc-pipefitting/W-G06.jpg": "c865",
	"./img/cpvc-pipefitting/W-G07.jpg": "2746",
	"./img/cpvc-pipefitting/W-G08.jpg": "00d5",
	"./img/cpvc-pipefitting/W-G09.jpg": "ffe9",
	"./img/cpvc-pipefitting/W-G10.jpg": "0844",
	"./img/cpvc-pipefitting/W-G11.jpg": "8f45",
	"./img/cpvc-pipefitting/W-G12.jpg": "5b9b",
	"./img/cpvc-pipefitting/W-G13.jpg": "4c70",
	"./img/cpvc-pipefitting/W-G14.jpg": "114b",
	"./img/cpvc-pipefitting/W-G15.jpg": "0c55",
	"./img/cpvc-pipefitting/W-G16.jpg": "8b02",
	"./img/cpvc-pipefitting/W-G17.jpg": "99cf",
	"./img/cpvc-pipefitting/W-G18.jpg": "5cef",
	"./img/cpvc-pipefitting/W-G19.jpg": "8823",
	"./img/cpvc-pipefitting/W-G20.jpg": "c5dd",
	"./img/cpvc-pipefitting/W-G22-1.jpg": "e023",
	"./img/cpvc-pipefitting/W-G22.jpg": "4aab",
	"./img/cpvc-pipefitting/W-G23.jpg": "7cb3",
	"./img/cpvc-pipefitting/W-G24.jpg": "a519",
	"./img/cpvc-pipefitting/W-G26.jpg": "14d1",
	"./img/cpvc-pipefitting/W-G27.jpg": "b711",
	"./img/cpvc-pipefitting/W-G28.jpg": "1277",
	"./img/cpvc-pipefitting/W-G30.jpg": "e5ea",
	"./img/cpvc-pipefitting/W-G31.jpg": "aea5",
	"./img/cpvc-pipefitting/W-G32.jpg": "eeca",
	"./img/cpvc-pipefitting/W-G33.jpg": "57b4",
	"./img/cpvc-pipefitting/W-G34.jpg": "7a2f",
	"./img/cpvc-pipefitting/W-G35.jpg": "ef26",
	"./img/cpvc-pipefitting/W-G37.jpg": "e761",
	"./img/cpvc-pipefitting/W-G38.jpg": "a3ed",
	"./img/cpvc-pipefitting/W-G39.jpg": "ef15",
	"./img/cpvc-pipefitting/W-G40.jpg": "be23",
	"./img/cpvc-pipefitting/W-G41.jpg": "e59b",
	"./img/cpvc-pipefitting/W-G42.jpg": "4bf3",
	"./img/cpvc-pipefitting/W-G43.jpg": "e080",
	"./img/cpvc-pipefitting/W-G44.jpg": "c7c6",
	"./img/cpvc-pipefitting/W-G45.jpg": "5671",
	"./img/cpvc-pipefitting/W-M01.jpg": "6ff9",
	"./img/cpvc-pipefitting/W-M02.jpg": "3921",
	"./img/cpvc-pipefitting/W-M03.jpg": "55b3",
	"./img/cpvc-pipefitting/W-M04.jpg": "f0ab",
	"./img/cpvc-pipefitting/W-M05.jpg": "d928",
	"./img/cpvc-pipefitting/W-M06.jpg": "8aae",
	"./img/cpvc-pipefitting/W-M10.jpg": "0b7b",
	"./img/cpvc-pipefitting/W-M101.jpg": "1327",
	"./img/cpvc-pipefitting/W-M12.jpg": "a795",
	"./img/cpvc-pipefitting/W-M13.jpg": "35ba",
	"./img/cpvc-pipefitting/W-M14.jpg": "2be5",
	"./img/cpvc-pipefitting/W-M15.jpg": "23fb",
	"./img/cpvc-pipefitting/W-M16.jpg": "b3b4",
	"./img/cpvc-pipefitting/W-M17.jpg": "446f",
	"./img/cpvc-pipefitting/W-M25.jpg": "cb9b",
	"./img/cpvc-pipefitting/W-M27.jpg": "7655",
	"./img/cpvc-pipefitting/W-M31.jpg": "fb95",
	"./img/cpvc-pipefitting/W-M33.jpg": "747e",
	"./img/cpvc-pipefitting/W-M36.jpg": "fb47",
	"./img/cpvc-pipefitting/W-M37.jpg": "b46c",
	"./img/cpvc-pipefitting/W-M38.jpg": "f54a",
	"./img/cpvc-pipefitting/W-M39.jpg": "fac0",
	"./img/cpvc-pipefitting/W-M63.jpg": "8062",
	"./img/cpvc-pipefitting/W-M64.jpg": "913c",
	"./img/cpvc-pipefitting/W-P45.jpg": "2a93",
	"./img/cpvc-pipefitting/W-SDR-11.jpg": "ea44",
	"./img/cpvc-pipefitting/W-SDR-13.5.jpg": "b74b",
	"./img/doubleLeverMixer/piedmont/large/AS0770003.jpg": "2316",
	"./img/doubleLeverMixer/piedmont/large/AS0770010.jpg": "0314",
	"./img/doubleLeverMixer/piedmont/large/AS0770027.jpg": "54fd",
	"./img/doubleLeverMixer/piedmont/small/AS0770003.jpg": "6456",
	"./img/doubleLeverMixer/piedmont/small/AS0770010.jpg": "0f7e",
	"./img/doubleLeverMixer/piedmont/small/AS0770027.jpg": "4056",
	"./img/drainagefitting/W-C01.jpg": "b282",
	"./img/drainagefitting/W-C02.jpg": "a1ba",
	"./img/drainagefitting/W-C03.jpg": "4453",
	"./img/drainagefitting/W-C04.jpg": "e0b5",
	"./img/drainagefitting/W-C06.jpg": "0f94",
	"./img/drainagefitting/W-C09.jpg": "d244",
	"./img/drainagefitting/W-C11.jpg": "94a2",
	"./img/drainagefitting/W-C128.jpg": "9aca",
	"./img/drainagefitting/W-C25.jpg": "90bc",
	"./img/drainagefitting/W-C30.jpg": "b59f",
	"./img/drainagefitting/W-C35.jpg": "f1fc",
	"./img/drainagefitting/W-C36.jpg": "9856",
	"./img/drainagefitting/W-C37.jpg": "c6d9",
	"./img/drainagefitting/W-C46.jpg": "d263",
	"./img/drainagefitting/W-C47.jpg": "caac",
	"./img/drainagefitting/W-C91.jpg": "732f",
	"./img/drainagefitting/W-C92.jpg": "b9bf",
	"./img/drainagefitting/W-C93.jpg": "90c0",
	"./img/drainagefitting/W-C94.jpg": "b54c",
	"./img/drainagefitting/W-C95.jpg": "b9b8",
	"./img/drainer/drainer/large/1.jpg": "82b2",
	"./img/drainer/drainer/large/2.jpg": "d770",
	"./img/drainer/drainer/large/3.jpg": "1ebe",
	"./img/drainer/drainer/small/1.jpg": "248d",
	"./img/drainer/drainer/small/2.jpg": "3dcc",
	"./img/drainer/drainer/small/3.jpg": "5cd0",
	"./img/drainer/magicHose/large/1.jpg": "3d1f",
	"./img/drainer/magicHose/large/2.jpg": "9064",
	"./img/drainer/magicHose/large/3.jpg": "7a7b",
	"./img/drainer/magicHose/small/1.jpg": "4eee",
	"./img/drainer/magicHose/small/2.jpg": "56bc",
	"./img/drainer/magicHose/small/3.jpg": "8ad5",
	"./img/drainer/sinkWaste/large/1.jpg": "153f",
	"./img/drainer/sinkWaste/large/2.jpg": "4e84",
	"./img/drainer/sinkWaste/large/3.jpg": "d82f",
	"./img/drainer/sinkWaste/small/1.jpg": "309c",
	"./img/drainer/sinkWaste/small/2.jpg": "c04d",
	"./img/drainer/sinkWaste/small/3.jpg": "9c35",
	"./img/h-pvcpipefitting/h-pvcpipefitting(pn-16)/W-A24.jpg": "43fb",
	"./img/h-pvcpipefitting/h-pvcpipefitting(pn-16)/W-D04.jpg": "1daa",
	"./img/h-pvcpipefitting/h-pvcpipefitting(pn-16)/W-S54.jpg": "6ec3",
	"./img/h-pvcpipefitting/h-pvcpipefitting(pn-16)/W-S55.jpg": "5afe",
	"./img/h-pvcpipefitting/h-pvcpipefitting(pn-16)/W-S56.jpg": "23f2",
	"./img/h-pvcpipefitting/h-pvcpipefitting(pn-16)/W-S57.jpg": "4ed6",
	"./img/h-pvcpipefitting/h-pvcpipefitting(pn-16)/W-S58.jpg": "ba4a",
	"./img/h-pvcpipefitting/h-pvcpipefitting(pn-16)/W-S59.jpg": "2b84",
	"./img/h-pvcpipefitting/h-pvcpipefitting(pn-16)/W-S60.jpg": "30f7",
	"./img/h-pvcpipefitting/h-pvcpipefitting(pn-16)/W-S61.jpg": "c045",
	"./img/h-pvcpipefitting/h-pvcpipefitting(pn-16)/W-S62.jpg": "2856",
	"./img/h-pvcpipefitting/h-pvcpipefitting(pn-16)/W-S63.jpg": "d1fa",
	"./img/h-pvcpipefitting/h-pvcpipefitting(pn-16)/W-S64.jpg": "7ccf",
	"./img/h-pvcpipefitting/h-pvcpipefitting(pn-16)/W-S65.jpg": "5fd9",
	"./img/h-pvcpipefitting/h-pvcpipefitting(pn-16)/W-S66.jpg": "0030",
	"./img/h-pvcpipefitting/h-pvcpipefitting(pn-16)/W-S67.jpg": "e4e7",
	"./img/h-pvcpipefitting/h-pvcpipefitting(pn-16)/W-S68.jpg": "cff0",
	"./img/h-pvcpipefitting/h-pvcpipefitting(pn-16)/W-S69.jpg": "8e12",
	"./img/h-pvcpipefitting/h-pvcpipefitting(pn-16)/W-S70.jpg": "7e2e",
	"./img/h-pvcpipefitting/h-pvcpipefitting(pn-16)/W-S71.jpg": "df63",
	"./img/h-pvcpipefitting/h-pvcpipefitting(pn-16)/W-V18.jpg": "3073",
	"./img/h-pvcpipefitting/h-pvcpipefitting(pn-16)/W-V31.jpg": "1b9b",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/S01.jpg": "5d83",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S02.jpg": "58f5",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S04.jpg": "8011",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S05.jpg": "5dea",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S06.jpg": "0d75",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S10.jpg": "43f2",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S11.jpg": "6d3c",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S12.jpg": "1e93",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S14.jpg": "243d",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S16.jpg": "6fff",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S17.jpg": "a040",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S19.jpg": "5516",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S25.jpg": "1139",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S27.jpg": "4113",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S31.jpg": "c3ad",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S32.jpg": "4e70",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S35.jpg": "a336",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S36.jpg": "7f91",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S37.jpg": "5142",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S38.jpg": "b47b",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S50.jpg": "e1af",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S51.jpg": "5fce",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S52.jpg": "0e52",
	"./img/h-pvcpipefitting/h-pvcpipefitting(sch-80)/W-S53.jpg": "03c5",
	"./img/h-pvcpipefitting/h-pvcpipefitting/W-V01.jpg": "3d46",
	"./img/h-pvcpipefitting/h-pvcpipefitting/W-V06.jpg": "00c7",
	"./img/h-pvcpipefitting/h-pvcpipefitting/W-V13.jpg": "c338",
	"./img/hose/flexiblehose/W-f-1-2-m-10-.jpg": "f4ba",
	"./img/hose/flexiblehose/W-f-f-1.2.jpg": "67c2",
	"./img/hose/flexiblehose/W-f-m-1.2.jpg": "8f47",
	"./img/hose/showerhose/W-f-f-1.2.jpg": "95cb",
	"./img/hose/showerhose/f-f-1.2.jpg": "8b77",
	"./img/pp-r-fitting/W-1.jpg": "b142",
	"./img/pp-r-fitting/W-10.jpg": "5a79",
	"./img/pp-r-fitting/W-12.jpg": "9514",
	"./img/pp-r-fitting/W-13.jpg": "d574",
	"./img/pp-r-fitting/W-14.jpg": "bb83",
	"./img/pp-r-fitting/W-15.jpg": "b17e",
	"./img/pp-r-fitting/W-16.jpg": "ad28",
	"./img/pp-r-fitting/W-17.jpg": "70a6",
	"./img/pp-r-fitting/W-18.jpg": "72c0",
	"./img/pp-r-fitting/W-19.jpg": "3e74",
	"./img/pp-r-fitting/W-2.jpg": "c73d",
	"./img/pp-r-fitting/W-20.jpg": "a594",
	"./img/pp-r-fitting/W-21.jpg": "345b",
	"./img/pp-r-fitting/W-22.jpg": "2dce",
	"./img/pp-r-fitting/W-23.jpg": "8424",
	"./img/pp-r-fitting/W-24.jpg": "4e34",
	"./img/pp-r-fitting/W-25.jpg": "ed24",
	"./img/pp-r-fitting/W-26.jpg": "78dd",
	"./img/pp-r-fitting/W-27.jpg": "95be",
	"./img/pp-r-fitting/W-28.jpg": "49e7",
	"./img/pp-r-fitting/W-29.jpg": "d3ba",
	"./img/pp-r-fitting/W-3.jpg": "d491",
	"./img/pp-r-fitting/W-30.jpg": "c9e1",
	"./img/pp-r-fitting/W-31.jpg": "abe0",
	"./img/pp-r-fitting/W-32.jpg": "5b2b",
	"./img/pp-r-fitting/W-33.jpg": "d3be",
	"./img/pp-r-fitting/W-34.jpg": "1e0e",
	"./img/pp-r-fitting/W-35.jpg": "117a",
	"./img/pp-r-fitting/W-4.jpg": "529e",
	"./img/pp-r-fitting/W-5.jpg": "4a09",
	"./img/pp-r-fitting/W-6.jpg": "33e5",
	"./img/pp-r-fitting/W-7.jpg": "b1a0",
	"./img/pp-r-fitting/W-8.jpg": "2378",
	"./img/pp-r-fitting/W-9.jpg": "e5e6",
	"./img/shattafSet/amarth/large/1.jpg": "778e",
	"./img/shattafSet/amarth/large/2.jpg": "a469",
	"./img/shattafSet/amarth/small/1.jpg": "abec",
	"./img/shattafSet/amarth/small/2.jpg": "f6ac",
	"./img/shattafSet/comfort/large/1.jpg": "7bc3",
	"./img/shattafSet/comfort/large/2.jpg": "f4a7",
	"./img/shattafSet/comfort/small/1.jpg": "c1d1",
	"./img/shattafSet/comfort/small/2.jpg": "03c1",
	"./img/shattafSet/gloria/large/1.jpg": "e29e",
	"./img/shattafSet/gloria/small/1.jpg": "93e3",
	"./img/shattafSet/lava/large/1.jpg": "43cd",
	"./img/shattafSet/lava/small/1.jpg": "02f7",
	"./img/shattafSet/lydia/large/1.jpg": "287c",
	"./img/shattafSet/lydia/large/2.jpg": "4860",
	"./img/shattafSet/lydia/small/1.jpg": "4f0f",
	"./img/shattafSet/lydia/small/2.jpg": "215d",
	"./img/shattafSet/modern/large/1.jpg": "551b",
	"./img/shattafSet/modern/large/2.jpg": "92f9",
	"./img/shattafSet/modern/small/1.jpg": "c0d3",
	"./img/shattafSet/modern/small/2.jpg": "ff06",
	"./img/shattafSet/sana/large/1.jpg": "75ee",
	"./img/shattafSet/sana/large/2.jpg": "129b",
	"./img/shattafSet/sana/small/1.jpg": "b74a",
	"./img/shattafSet/sana/small/2.jpg": "228e",
	"./img/shattafSet/shifa/large/1.jpg": "2d8c",
	"./img/shattafSet/shifa/large/2.jpg": "4b11",
	"./img/shattafSet/shifa/small/1.jpg": "a639",
	"./img/shattafSet/shifa/small/2.jpg": "0f4e",
	"./img/shattafSet/viva/large/1.jpg": "e42f",
	"./img/shattafSet/viva/small/1.jpg": "3d34",
	"./img/showerSet/large/1.jpg": "6198",
	"./img/showerSet/large/2.jpg": "a742",
	"./img/showerSet/large/3.jpg": "07cf",
	"./img/showerSet/large/4.jpg": "da73",
	"./img/showerSet/large/5.jpg": "a1f9",
	"./img/showerSet/small/1.jpg": "5bd4",
	"./img/showerSet/small/2.jpg": "b0e1",
	"./img/showerSet/small/3.jpg": "2160",
	"./img/showerSet/small/4.jpg": "1ed4",
	"./img/showerSet/small/5.jpg": "2129",
	"./img/singleLeverMixer/hasa/large/1.jpg": "d10f",
	"./img/singleLeverMixer/hasa/large/2.jpg": "2683",
	"./img/singleLeverMixer/hasa/large/3.jpg": "94c0",
	"./img/singleLeverMixer/hasa/large/4.jpg": "4819",
	"./img/singleLeverMixer/hasa/small/1.jpg": "3107",
	"./img/singleLeverMixer/hasa/small/2.jpg": "089d",
	"./img/singleLeverMixer/hasa/small/3.jpg": "f01e",
	"./img/singleLeverMixer/hasa/small/4.jpg": "7430",
	"./img/singleLeverMixer/lucky/large/1.jpg": "d646",
	"./img/singleLeverMixer/lucky/large/2.jpg": "9c350",
	"./img/singleLeverMixer/lucky/large/3.jpg": "195c",
	"./img/singleLeverMixer/lucky/large/4.jpg": "d906",
	"./img/singleLeverMixer/lucky/small/1.jpg": "be71",
	"./img/singleLeverMixer/lucky/small/2.jpg": "7296",
	"./img/singleLeverMixer/lucky/small/3.jpg": "89cd",
	"./img/singleLeverMixer/lucky/small/4.jpg": "ee4c",
	"./img/singleLeverMixer/pola/large/1.jpg": "2dde",
	"./img/singleLeverMixer/pola/large/2.jpg": "97ef",
	"./img/singleLeverMixer/pola/large/3.jpg": "2b2a",
	"./img/singleLeverMixer/pola/large/4.jpg": "5f09",
	"./img/singleLeverMixer/pola/small/1.jpg": "e61d",
	"./img/singleLeverMixer/pola/small/2.jpg": "4d4a",
	"./img/singleLeverMixer/pola/small/3.jpg": "96ee",
	"./img/singleLeverMixer/pola/small/4.jpg": "eb22",
	"./img/singleLeverMixer/siru/large/1.jpg": "5a86",
	"./img/singleLeverMixer/siru/large/2.jpg": "87b6",
	"./img/singleLeverMixer/siru/large/3.jpg": "a75e",
	"./img/singleLeverMixer/siru/large/4.jpg": "db51",
	"./img/singleLeverMixer/siru/small/1.jpg": "f936",
	"./img/singleLeverMixer/siru/small/2.jpg": "feff",
	"./img/singleLeverMixer/siru/small/3.jpg": "12ad",
	"./img/singleLeverMixer/siru/small/4.jpg": "7c4e",
	"./img/singleLeverMixer/vicky/large/1.jpg": "5334",
	"./img/singleLeverMixer/vicky/large/2.jpg": "44eb",
	"./img/singleLeverMixer/vicky/large/3.jpg": "b720",
	"./img/singleLeverMixer/vicky/large/4.jpg": "0428",
	"./img/singleLeverMixer/vicky/small/1.jpg": "1a69",
	"./img/singleLeverMixer/vicky/small/2.jpg": "47aa",
	"./img/singleLeverMixer/vicky/small/3.jpg": "cc71",
	"./img/singleLeverMixer/vicky/small/4.jpg": "ac25",
	"./img/valve/angleValve/large/1.jpg": "7c02",
	"./img/valve/angleValve/large/2.jpg": "cd53",
	"./img/valve/angleValve/large/3.jpg": "bfe9",
	"./img/valve/angleValve/large/4.jpg": "5d44",
	"./img/valve/angleValve/large/5.jpg": "979f",
	"./img/valve/angleValve/small/1.jpg": "5e96",
	"./img/valve/angleValve/small/2.jpg": "70db",
	"./img/valve/angleValve/small/3.jpg": "019a",
	"./img/valve/angleValve/small/4.jpg": "8508",
	"./img/valve/angleValve/small/5.jpg": "89a7",
	"./img/valve/ballValve/large/1.jpg": "ad9f",
	"./img/valve/ballValve/small/1.jpg": "bece",
	"./img/valve/bibcock/large/1.jpg": "1473",
	"./img/valve/bibcock/small/1.jpg": "5cc7",
	"./img/valve/gateValve/large/1.jpg": "f3e7",
	"./img/valve/gateValve/small/1.jpg": "4a00",
	"./img/water pump/AS-12A.jpg": "be0c",
	"./img/water pump/QB60.jpg": "a158",
	"./img/water pump/W-AS-12A.jpg": "e1fe",
	"./img/water pump/W-QB60.jpg": "8a97",
	"./img/water pump/W-as1.jpg": "5277",
	"./img/water pump/W-as13.jpg": "5e95",
	"./img/water pump/W-as3.jpg": "0053",
	"./img/water pump/W-cpm158.jpg": "1090",
	"./img/water pump/W-hf5bm.jpg": "9178",
	"./img/water pump/as1.jpg": "419a",
	"./img/water pump/as13.jpg": "3624",
	"./img/water pump/as3.jpg": "1663",
	"./img/water pump/cpm158.jpg": "6f55",
	"./img/water pump/hf5bm.jpg": "f355",
	"./img/waterFilter/large/1.jpg": "e023b",
	"./img/waterFilter/large/10.jpg": "08c2",
	"./img/waterFilter/large/11.jpg": "b42a",
	"./img/waterFilter/large/2.jpg": "2eac",
	"./img/waterFilter/large/3.jpg": "403d",
	"./img/waterFilter/large/4.jpg": "7804",
	"./img/waterFilter/large/5.jpg": "a6a4",
	"./img/waterFilter/large/6.jpg": "3c8e",
	"./img/waterFilter/large/7.jpg": "7ef8",
	"./img/waterFilter/large/8.jpg": "70d3",
	"./img/waterFilter/large/9.jpg": "0e80",
	"./img/waterFilter/small/1.jpg": "8f53",
	"./img/waterFilter/small/10.jpg": "0b53",
	"./img/waterFilter/small/11.jpg": "b292",
	"./img/waterFilter/small/2.jpg": "3a42",
	"./img/waterFilter/small/3.jpg": "49fd",
	"./img/waterFilter/small/4.jpg": "e88e",
	"./img/waterFilter/small/5.jpg": "5844",
	"./img/waterFilter/small/6.jpg": "8c21",
	"./img/waterFilter/small/7.jpg": "c8c9",
	"./img/waterFilter/small/8.jpg": "ba10",
	"./img/waterFilter/small/9.jpg": "3c19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d05";